<div class="protocol-container">
    <ng-container *ngFor="let observe of observeProtocal; let i = index">
        <div class="d-flex justify-content-between timeline-date" *ngIf="timeLine[i] != false">
            <div class="col-auto icon-date p-0">
                <p class="m-0 date-label">{{timeLine[i] | translate}}</p>
            </div>
            <div class="col-auto text-right p-0">
                <p class="m-0 sop-label-information">{{entryValue[i]}} {{(entryValue[i] < 2)?( 'SOP_OBSERVATION.ENTRY' |translate):( 'SOP_OBSERVATION.ENTRIES' | translate)}}</p>
            </div>
        </div>

        <div class="col-12 p-0 card-strip card-strip-protocol d-flex" (click)="viewOpobserve(i)">
            <div class="card-task mb-0">
                <div class="d-none d-md-flex card-task-media">
                    <img [ngClass]="observe.isInstitutionImage?'imgFilter':''" 
                    [src]=" observe.sopImage? layoutService.serverUrl+observe.sopImage : 'assets/img/fallback-img-gray.png'" 
                    (error)="errImg($event)">
                </div>
                <div class="col card-task-content d-flex justify-content-between">
                    <div class="col-12 p-0">
                        <div class="d-flex justify-content-between mt-3">
                            <span class="published hour-label">{{layoutService.convertUTCStingToLocalDate(observe.createdDataTime) | date:'H:mm' }} | {{ translationKeys.Observation.CreatedBy | translate }} {{observe.createdByUserName}}</span>
                            <div class="pr-2">
                                <span class="sop-label-information">{{observe.wardName | translate | labelSanitizer}}</span>
                                <span class="specs-center sop-label-information">{{observe.departmentName | translate | labelSanitizer}}</span>
                                <span class="sop-label-information">{{observe.professsionalCategory | translate | labelSanitizer}}</span>
                                <span class="specs-sub sop-label-information" *ngIf="showProfessionalSubcategory" >{{observe.professionalSubCategory | translate | labelSanitizer}}</span>
                            </div>
                        </div>
                        <!--<div class="card-task-title">{{observe.sopName | translate}}</div>-->
                        <div class="mt-4 card-task-title sop-label-title">{{getSopName(observe.observationID) | labelSanitizer}}</div>
                        <!--<span class="card-task-desc">{{observe.sopDescription | translate}}</span>-->
                        <span class="card-task-desc sop-label-description">{{getDescription(observe.observationID) | labelSanitizer}}</span>
                        <!-- <ul class="advise-container">
                            <li>{{observe.wardName | translate | labelSanitizer}}</li>
                            <li>{{observe.departmentName | translate | labelSanitizer}}</li>
                            <li>{{observe.professsionalCategory | translate | labelSanitizer}}</li>
                            <li *ngIf="showProfessionalSubcategory">{{observe.professionalSubCategory | translate | labelSanitizer}}</li>
                        </ul> -->
                    </div>
                    <!-- <div class="col-1 align-items-center d-flex p-0 justify-content-center">
                        <span class="color9B">
              <img class="doubleTick" src="assets/img/SOP-Images/double-tick.svg" 
                (error)="errImg($event)">
            </span>
                    </div> -->
                </div>
            </div>
        </div>
    </ng-container>
</div>
<div class="alert alert-warning" role="alert" *ngIf="noDataFound">{{ translationKeys.Dashboard.NoDataFound | translate }}</div>